'use client'

import srOnly from '@fukku/styles/src/srOnly.module.css'
import textBodyM from '@fukku/styles/texts/textBodyM.module.css'
import { cx } from 'classix'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { replacePlaceholders } from 'labels/lib/replacePlaceholders'
import styles from './ExtraColors.module.css'

interface ExtraColorsProps {
	readonly dataTestId?: string
	readonly extraColors: number
}
export function ExtraColors({ dataTestId, extraColors }: ExtraColorsProps) {
	const { t } = useLabels()

	const accessibilityLabel = replacePlaceholders(
		t('accessibility.colorSelector.moreColors.button', extraColors),
		{ 1: extraColors }
	)
	return (
		<>
			<span
				aria-hidden='true'
				className={cx(styles.extraColors, textBodyM.className)}
				{...(dataTestId && { 'data-testid': `${dataTestId}.extraColors` })}
			>
				+{extraColors}
			</span>
			<span className={srOnly.className}>{accessibilityLabel}</span>
		</>
	)
}
